/* eslint-disable no-unexpected-multiline */
import { useState, useEffect, SetStateAction, Dispatch, useRef } from 'react'
import { Toast } from 'components/ChipInput'
import { yupResolver } from '@hookform/resolvers/yup'
import { AxiosResponse } from 'axios'
import {
  Button,
  CheckBox,
  Col,
  Form,
  Grid,
  Input,
  InputFile,
  Picker,
  Row,
  Span,
  Modal,
  SuccessModal,
  ChipInput,
  AutoCompleteInput,
  TextArea,
  UnidadeGestoraFields,
  AutoCompleteSearchTerm
} from 'components'
import SimpleCollapse from 'components/Collapse/SimpleCollapse'
import { LoadingIcon, MagnifyingGlassIcon } from 'components/Icons'
import { useEnvironment, useModal } from 'hooks'
import useAuth from 'hooks/useAuth'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import GenericServices from 'services/Generic/Generic'
import {
  ContractServices,
  ContractNGTServices,
  ICentroPlanta,
  ISubstitutosInputs,
  IContraparteSubstitutos,
  ISaveFileRequest,
  ResponseContractById
} from 'services/NGT/Contract'
import {
  ItemProductServices,
  ItemProdutoContratoResponseDto
} from 'services/NGT/ItemProduct'
import {
  FornecedorServices,
  IGetCsnUserByResponse,
  UserCsnService,
  UserServices
} from 'services/Supplier/Users'
import { UnidadeGestoraServices } from 'services/Utils/UnidadeGestora'
import { COLORS, FONTS, PATTERNS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'
import { convertBase64, preventDefaultOnEnter } from 'utils/functions'
import { ITypeUpload } from 'utils/types'
import * as yup from 'yup'

import { SubContract } from '../SubContract/SubContract'
import FakeAttachedFiles from './components/FakeAttachedFiles'

interface FormProps {
  setTab?: Dispatch<SetStateAction<number>>
  dtCadastro: Date
  flPrincipal?: boolean
  flSap: boolean
  costCenters: ICentroPlanta[]
  sectors: any
  unidadesGestoras: any
  tipoCre: any
  contractID: number | string
}

const dateNow = new Date()

export const ViewContract: React.FC<FormProps> = ({
  setTab,
  dtCadastro,
  tipoCre,
  flSap,
  contractID,
  costCenters,
  sectors
}) => {
  const { setLoading, setMsgErro } = useLoading()
  const { user } = useAuth()

  const schema = yup.object({
    CRE: yup.string().typeError('CRE obrigatório').required('CRE obrigatório'),
    emailsTrabalhistas: yup
      .array()
      .min(1, 'Informe pelo menos um E-mail')
      .test('invalid', 'Informe pelo menos um E-mail', (emails) => {
        return emails.some((_, index) => !flExclusao[index])
      }),
    setorId: yup
      .number()
      .notOneOf([0], 'Negócio obrigatório')
      .required('Negócio obrigatório')
      .typeError('Negócio Obrigatório'),
    txAlerta: yup.string().when('flAlerta', {
      is: true,
      then: yup
        .string()
        .required('Opção de alerta selecionada mas nenhuma é inserida')
    }),
    txDenuncia: yup.string().when('flDenuncia', {
      is: true,
      then: yup
        .string()
        .required('Opção de denúncia selecionada mas nenhuma é inserida')
    })
  })

  const {
    control,
    watch,
    handleSubmit,
    reset,
    setValue,
    register,
    setError,
    clearErrors,
    getFieldState,
    getValues,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const centroPlantaName = watch('centroPlantaName')
  const setorName = watch('setorName')
  const dtVigInicoReal = watch('dtVigInicoReal')
  const dtVigFimReal = watch('dtVigFimReal')
  const unidadeGestoraId = watch('idUnidadeGestora')
  const creNameValue = watch('CRE');
  const { showModal } = useModal()
  const [itemProdutoValue, setItemProdutoValue] = useState<string>()
  const [descHierarquiaProduto, setDescHierarquiaProduto] = useState<string>()
  const [alterarItemProduto, setAlterarItemProduto] = useState<boolean>(false)
  const [itemProdutos, setItemProdutos] =
    useState<ItemProdutoContratoResponseDto[]>()
  const [searchFile, setSearchFile] = useState<string>('')
  const [fileToDelete, setFileToDelete] = useState<number[]>([])
  const [arquivosSelecionados, setArquivosSelecionados] = useState<
    ITypeUpload[]
  >([])
  const [contract, setContract] = useState<ResponseContractById>(null)
  const [subContract, setSubContract] = useState<any | null>(null)
  const [isQuarteirizacao, setIsQuarteirizacao] = useState<boolean>(false)
  const [flagUnidadeManual, setUnidadeManual] = useState<boolean>(false)
  const [openModal, toggleModal] = useToggle()
  const [loadingEvidencia, setLoadingEvidencia] = useState<boolean>(false)
  const [successMsg, setSuccessMsg] = useState<string>('')
  const [isSuccess, setSuccess] = useState<boolean>(false)
  const [isError, toggleError] = useToggle()
  const [substituteErrorMsg, setSubstituteErrorMsg] = useState<string>('')

  const [flagContratoEncerrado, setFlagContratoEncerrado] =
    useState<boolean>(false)
  const [flagSubcontrato, setFlagSubcontrato] = useState<boolean>(false)
  const [flagSocio, setFlagSocio] = useState<boolean>(false)
  const [flagDenuncia, setFlagDenuncia] = useState<boolean>(false)
  const [flagAlerta, setFlagAlerta] = useState<boolean>(false)
  const [flagRecorrente, setFlagRecorrente] = useState<boolean>(false)
  const [unidadeCompradorId, setUnidadeCompradorId] = useState<string>()
  const [flExclusao, setFlExclusao] = useState<boolean[]>([])
  const [
    arquivosSelecionadosComFlagEncerrado,
    setArquivosSelecionadosComFlagEncerrado
  ] = useState<ITypeUpload[]>([])
  const [flagContratoEncerradoWasEnabled, setFlagContratoEncerradoWasEnabled] =
    useState<boolean>(false)

  const { website_url } = useEnvironment()

  const cdContrato = watch('cdContrato')

  const [semPreenchimento, setSemPreenchimento] = useState(false);

  const [substitutoList, setSubstitutoList] = useState<ISubstitutosInputs[]>([
    {
      emailSubstituto: '',
      idSubstituto: 0,
      matriculaSubstituto: '',
      nmSubstituto: '',
      ramalSubstituto: ''
    }
  ])

  const inputTypingValue = useRef<string>('')

  const [matriculas, setMatriculas] = useState<{ label: string; value: any }[]>(
    [{ label: '', value: {} }]
  )

  const [analistas, setAnalistas] = useState<{ label: string; value: any }[]>([
    { label: '', value: {} }
  ])

  const [dataAtualizacaoSAP, setDataAtualizacaoSAP] = useState<Date>()

  const getItemProducts = (cdContrato: string) => {
    ItemProductServices()
      .GetItemProductsByCdContract(cdContrato)
      .then((response) => {
        if (response?.status == 200) {
          setItemProdutos(response?.data)
        } else {
          showModal({
            message: 'Ocorreu um problema ao buscar os itens do contrato.',
            txtButtonCancel: '',
            txtButtonConfirm: 'Fechar',
            type: 'alert'
          })
        }
      })
  }

  const getEvidencias = async (contratoPrincipalId: number | null) => {
    setLoadingEvidencia(true)
    let subContrato = 1
    if (contratoPrincipalId !== 0 && contratoPrincipalId !== null) {
      subContrato = 2
    } else {
      subContrato = 1
    }

    try {
      const response = await GenericServices.GetEvidencia(
        contractID,
        subContrato
      )

      // Se vier string vazia ou nada seta array vazia pra não quebrar
      setArquivosSelecionados(response?.data || [])
      setLoadingEvidencia(false)
    } catch (err: any) {
      setLoadingEvidencia(false)
      setMsgErro('Não foi possivel carregar evidencias.')
      setLoading('error')
    }
  }

  const handleChangeInput = (value, field) => setValue(field, value)

  const getDescHirarquiaProd = () => {
    const item = itemProdutos?.find(
      (itemProd) => itemProd?.idItemProduto == Number(itemProdutoValue)
    )
    setDescHierarquiaProduto(item?.codHierarquiaProduto)
  }

  const handleInputChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setSubstitutoList((prevList) =>
      prevList.map((item, idx) =>
        idx === index ? { ...item, [name]: value } : item
      )
    );
  };

  useEffect(() => {
    getDescHirarquiaProd()
  }, [itemProdutoValue])

  const OpenModalErrorUnidGestora = () => {
    showModal({
      hideButtonCancel: true,
      message:
        'Escolha uma unidade gestora e salve antes de gerar o subcontrato.',
      txtButtonConfirm: 'Fechar',
      type: 'alert'
    })
  }

  const handleSearchMatricula = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setMatriculas([])
    if (event.target.value === '') {
      return
    }
    UserCsnService()
      .getByMatricula(event.target.value)
      .then((response: AxiosResponse<IGetCsnUserByResponse[]>) => {
        const selectedFieldOptions = response.data.map(
          (analista: IGetCsnUserByResponse) => ({
            label: analista.nmMatricula,
            value: analista
          })
        )

        setMatriculas(selectedFieldOptions)
      })
  }

  const handleSearchAnalista = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAnalistas([])
    if (event.target.value === '') {
      return
    }

    UserCsnService()
      .getByNome(event.target.value)
      .then((response: AxiosResponse<IGetCsnUserByResponse[]>) => {
        const selectedFieldOptions = response.data.map(
          (analista: IGetCsnUserByResponse) => ({
            label: analista.usuario.nmUsuario,
            value: analista
          })
        )

        setAnalistas(selectedFieldOptions)
      })
  }

  const handleSelectedSubstituto = (
    substituto: IGetCsnUserByResponse,
    index: number
  ) => {
    const newList = [...substitutoList];

    newList[index] = {
      ...newList[index],
      idSubstituto: substituto?.usuarioId,
      matriculaSubstituto: substituto?.nmMatricula,
      nmSubstituto: substituto.usuario?.nmUsuario,
      ramalSubstituto: substituto.usuario?.nuRamal,
      emailSubstituto: substituto.usuario?.txEmail,
    }
    const listaSemDuplicatas = removerDuplicatedSubstitutos(newList)
    setSubstitutoList(listaSemDuplicatas)
  }

  const removerDuplicatedSubstitutos = (
    substitutoList: ISubstitutosInputs[]
  ): ISubstitutosInputs[] => {
    const listaSemDuplicatas: ISubstitutosInputs[] = []
    substitutoList.forEach((itemComparador, lenght) => {
      const nmItemComparado = substitutoList[lenght + 1]?.nmSubstituto
        ? substitutoList[lenght + 1].nmSubstituto
        : null
      if (nmItemComparado !== itemComparador.nmSubstituto)
        listaSemDuplicatas.push(itemComparador)
    })
    return listaSemDuplicatas
  }

  const generateInputToken = (length = 10) => {
    let aleatoryString = ''

    const caracteres =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    for (let i = 0; i < length; i++) {
      aleatoryString += caracteres.charAt(
        Math.floor(Math.random() * caracteres.length)
      )
    }

    return aleatoryString
  }

  const removeSubstitutoInput = (inputID: number) => {
    if (substitutoList?.length == 1) {
      setSubstitutoList([
        {
          emailSubstituto: '',
          idSubstituto: 0,
          matriculaSubstituto: '',
          nmSubstituto: '',
          ramalSubstituto: ''
        }
      ])
    } else {
      setSubstitutoList([
        ...substitutoList.filter((_, index: number) => index !== inputID)
      ])
    }
  }

  const addSubstituto = () => {
    setSubstitutoList((prevList) => [
      ...prevList,
      {
        emailSubstituto: '',
        idSubstituto: 0,
        matriculaSubstituto: '',
        nmSubstituto: '',
        ramalSubstituto: ''
      }
    ]);
  };

  const changeContractValues = (contract: any) => {
    const formatContractValue = contract.vlContratual
      .toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })
      .toString()

    handleChangeInput(contract.cdContrato, 'cdContrato')
    handleChangeInput(contract.cnpj?.trim(), 'cnpj')
    handleChangeInput(contract.nmFornecedor?.trim(), 'nmFornecedor')
    handleChangeInput(contract.nmEmpresa?.trim(), 'nmEmpresa')
    handleChangeInput(contract.nmCentro?.trim(), 'centroPlantaName')
    handleChangeInput(contract.centroPlantaId, 'centroPlantaId')

    handleChangeInput(contract?.txObjetoContrato?.trim(), 'txObjetoContrato')
    handleChangeInput(contract?.nmCRE?.trim(), 'creName')
    handleChangeInput(contract?.tipoCreId, 'CRE')
    handleChangeInput(contract.txCno?.trim(), 'txCno')
    handleChangeInput(contract.flSocio, 'flSocio')

    setFlagContratoEncerrado(contract.flEncerrado)
    setFlagSubcontrato(contract.flSubcontrato)
    setFlagSocio(contract.flSocio)
    setFlagDenuncia(contract.flDenuncia)
    setFlagAlerta(contract.flAlerta)
    setFlagRecorrente(contract.flRecorrente)

    handleChangeInput(
      contract.dtVigInicoReal === '0001-01-01T00:00:00'
        ? null
        : contract.dtVigInicoReal,
      'dtVigInicoReal'
    )
    handleChangeInput(
      contract.dtVigFimReal === '0001-01-01T00:00:00'
        ? null
        : contract.dtVigFimReal,
      'dtVigFimReal'
    )
    handleChangeInput(
      contract.dtVigenciaInicio === '0001-01-01T00:00:00'
        ? null
        : contract.dtVigenciaInicio,
      'dtVigenciaInicio'
    )
    handleChangeInput(
      contract.dtVigenciaFim === '0001-01-01T00:00:00'
        ? null
        : contract.dtVigenciaFim,
      'dtVigenciaFim'
    )
    handleChangeInput(formatContractValue, 'vlContratual')
    handleChangeInput(contract.nmSetor, 'setorName')
    handleChangeInput(contract.txDenuncia?.trim(), 'txDenuncia')
    handleChangeInput(contract.txAlerta?.trim(), 'txAlerta')
    handleChangeInput(
      contract.matriculaContraparte?.trim(),
      'matriculaContraparte'
    )

    handleChangeInput(contract.nmContraparte?.trim(), 'nmContraparte')
    handleChangeInput(contract.ramalContraparte?.trim(), 'ramalContraparte')
    handleChangeInput(contract.emailContraparte?.trim(), 'emailContraparte')
    handleChangeInput(contract.matriculaComprador?.trim(), 'matriculaComprador')
    handleChangeInput(contract.nmComprador?.trim(), 'nmComprador')
    handleChangeInput(contract.ramalComprador?.trim(), 'ramalComprador')
    handleChangeInput(contract.emailComprador?.trim(), 'emailComprador')
    handleChangeInput(contract.cdGrupoMercadoria?.trim(), 'cdGrupoMercadoria')
    handleChangeInput(contract.cdHierarquiaProd?.trim(), 'cdHierarquiaProd')
    handleChangeInput(contract.txObservacao?.trim(), 'txObservacao')
    handleChangeInput(contract.nmUnidadeGestora?.trim(), 'nmUnidadeGestora')
    handleChangeInput(contract.unidadeGestoraId, 'idUnidadeGestora')
    handleChangeInput(
      contract.txEmails?.map((email) => email.txEmail) || [],
      'emailsTrabalhistas'
    )

    contract.txEmails?.map(() =>
      setFlExclusao((prevState) => [...prevState, false])
    )

    handleChangeInput(contract.setorId, 'setorId')

    if (contract.contraparteSubstitutos?.length > 0) {
      setSubstitutoList(
        contract.contraparteSubstitutos.map(
          (substituto: IContraparteSubstitutos) => ({
            emailSubstituto: substituto.emailContraparteSub,
            idSubstituto: substituto.usuarioId,
            matriculaSubstituto: substituto.matriculaContraparteSub,
            nmSubstituto: substituto.nmContraparteSub,
            ramalSubstituto: substituto.ramalContraparteSub
          })
        )
      )
    }
  }



  useEffect(() => {
    if (PATTERNS.outsourcing.test(cdContrato)) {
      setIsQuarteirizacao(true)
      setIsSub(true)
    }

    if (PATTERNS.subcontract.test(cdContrato)) {
      setIsSub(true)
    }
  }, [cdContrato])

  const [isSub, setIsSub] = useState(false)
  const getContract = () => {
    setLoading('loading')

    ContractServices()
      .GetContractById(contractID)
      .then((response: any) => {
        const { data: contract } = response
        if (PATTERNS.outsourcing.test(contract?.cdContrato)) {
          setIsQuarteirizacao(true)
          setIsSub(true)
        }

        if (
          PATTERNS.subcontract.test(contract?.cdContrato) ||
          PATTERNS.outsourcing.test(contract?.cdContrato)
        ) {
          setIsSub(true)
          getContratoPrincipal(contract)
        }

        getItemProducts(contract?.cdContrato)
        getUnidadeComprador(contract?.idUnidadeComprador)
        setItemProdutoValue(contract?.itemProdutoPrincipalId)
        setDataAtualizacaoSAP(contract?.dtAtualizacaoSap)

        if (response.status === 200) {
          setUnidadeManual(contract.flUnidadeManual)
          setContract(contract)
          getEvidencias(contract.contratoPrincipalId)
          changeContractValues(contract)
        }

        setLoading('idle')
      })
      .catch((error) => {
        if (JSON.stringify(error === '{}')) return setLoading('idle')
        setLoading('error')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os dados do contrato.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const getUnidadeComprador = (idUnidadeComprador: number) => {
    setLoading('loading')
    UnidadeGestoraServices()
      .getById(idUnidadeComprador)
      .then((response) => {
        if (response?.status == 200) {
          handleChangeInput(response?.data?.numeroUnidade, 'unidadeComprador')
          setUnidadeCompradorId(response?.data?.numeroUnidade)
          setLoading('idle')
        } else {
          setLoading('idle')
          showModal({
            message: 'Ocorreu um problema ao buscar a unidade do comprador.',
            txtButtonCancel: '',
            txtButtonConfirm: 'Fechar',
            type: 'alert'
          })
        }
      })
    setLoading('idle')
  }

  const handleFilterFilesTable = () => {
    if (searchFile !== '') {
      return arquivosSelecionados?.filter(
        (file) =>
          file?.dsDocumento?.toLowerCase().includes(searchFile.toLowerCase()) ||
          file?.dsExtensaoDoc?.toLowerCase().includes(searchFile.toLowerCase())
      )
    }

    return arquivosSelecionados
  }

  const handleFileToDelete = (file: ITypeUpload) => {
    if (!flagContratoEncerrado) {
      if (file.anexoDocumentoId) {
        // Documento já está na base, insere na lista de ids a serem deletados
        setFileToDelete((prevState: number[]) => [
          ...prevState,
          file.anexoDocumentoId
        ])
      }
      // Documento temporário ainda não salvo, só remove do estado
      setArquivosSelecionados((prevState) =>
        prevState.filter((evidencia) => evidencia !== file)
      )
    } else {
      showModal({
        message:
          'Não é possivel deletar o anexo, pois a flag de contrato encerrado está ou foi ativado!',
        txtButtonCancel: '',
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
    }
  }

  const handleDeleteFiles = async () => {
    if (fileToDelete.length <= 0) return Promise.resolve(true)

    const { contratoPrincipalId } = contract

    // Bate no endpoint de contrato ou sub
    const deleteEvidencia = (id: number) => {
      if (contratoPrincipalId !== 0 && contratoPrincipalId !== null) {
        return ContractNGTServices().deleteAnexarEvidenciaSubContrato(id)
      }
      return ContractNGTServices().deleteAnexarEvidenciaContrato(id)
    }

    const requests = fileToDelete.map((id) => deleteEvidencia(id))

    return Promise.all(requests)
      .then(() => true)
      .catch(() => {
        showModal({
          message:
            'Ocorreu um erro inesperado ao deletar a(s) evidência(s), por favor, verifique-as e tente novamente.',
          txtButtonCancel: '',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })

        return false
      })
      .finally(() => setLoading('idle'))
  }

  const getContractType = (): number => {
    if (PATTERNS.subcontract.test(contract?.cdContrato)) {
      return 2
    }

    if (PATTERNS.outsourcing.test(contract?.cdContrato)) {
      return 3
    }

    return 1
  }

  const handleChangeFile = async (files) => {
    if (files) {
      setLoading('loading')
      // try {
      for (let i = 0; i < files.length; i++) {
        const fileBase64 = (await convertBase64(files[i])) as string
        const newObj: ITypeUpload = {
          base64: FORMAT.file(fileBase64),
          documentoExternoGedId: String(generateInputToken(10)),
          dsDocumento: files[i].name,
          dsExtensaoDoc: files[i].type || 'application/octet-stream',
          filename: files[i].name
        }

        setArquivosSelecionados((prevState) => [...prevState, newObj])
      }
      setLoading('idle')
    }
  }

  const handleClearForm = () => {
    setFlagContratoEncerrado(false)
    setFlagSubcontrato(false)
    setFlagSocio(false)
    setFlagDenuncia(false)
    setFlagAlerta(false)
    setFlagRecorrente(false)

    reset({
      CRE: contract.tipoCreId,
      cdGrupoMercadoria: contract.cdGrupoMercadoria,
      cdHierarquiaProd: contract.cdHierarquiaProd,
      centroPlantaId: contract.centroPlantaId,
      centroPlantaName: contract.nmCentro?.trim(),
      creName: contract.nmCRE?.trim(),
      descGrupoMercadoria: '',
      descHierarquiaProduto: '',
      dtVigFimReal: contract.dtVigFimReal,
      dtVigInicoReal: contract.dtVigInicoReal,
      emailSubstituto0: '',
      emailsTrabalhistas: [],
      flAlerta: false,
      flDenuncia: false,
      flEncerrado: false,
      flRecorrente: false,
      flSocio: false,
      flSubcontrato: contract.flSubcontrato,
      idUnidadeGestora: contract.unidadeGestoraId,
      matriculaSubstituto0: '',
      nameSubstituto0: '',
      nmUnidadeGestora: contract.nmUnidadeGestora?.trim(),
      ramalSubstituto0: '',
      setorName: contract.nmSetor,
      // tipoDescricao: "",
      txAlerta: '',
      txCno: '',
      txDenuncia: '',
      txObservacao: ''
    })
  }

  const getSubstitutesIDS = (form: any) => {
    const substitutesIDS = []

    Object.keys(form).forEach((key) => {
      const value = form[key]

      if (/idSubstituto.*/g.test(key)) {
        substitutesIDS.push(value)
      }
    })

    const uniqSubstitutesIDS = [...new Set(substitutesIDS)]

    return uniqSubstitutesIDS
  }

  const validateSubstitutes = (form: any) => {
    let isValid = true
    const substitutesIDS = getSubstitutesIDS(form)

    if (
      substitutesIDS.includes(
        contract?.contraparteUsuarioId || contract?.compradorUsuarioId
      )
    ) {
      isValid = false
    }

    return isValid
  }

  const handleSubmitForm = async (form) => {
    if (inputTypingValue.current) {
      setError('emailsTrabalhistas', {
        message:
          'Existem emails que foram preenchidos parcialmente, pressione espaço para finalizar o preenchimento!',
        type: 'custom'
      })
      return
    }

    setLoading('loading')

    const idUnidGestora = form?.idUnidadeGestora

    if (!idUnidGestora) {
      showModal({
        hideButtonCancel: true,
        message: 'Por favor, Selecione uma unidade gestora.',
        titleModal: 'Atenção',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
      setLoading('idle')
      return
    }

    const idSubstitutoList: number[] | undefined =
      substitutoList[0].idSubstituto !== 0
        ? substitutoList.map(
          (substituto: ISubstitutosInputs) => substituto.idSubstituto
        )
        : []

    const substitutoRegex = new RegExp('idSubstituto([a-zA-Z0-4]+)')

    const handleUpdateRamal = async () => {
      let substitutoValues = {}
      let substitutosList = []
      for (const key in form) {
        if (/ramalSubstituto/g.test(key) || /idSubstituto/g.test(key)) {
          if (form[key] !== undefined) {
            substitutoValues = {
              ...substitutoValues,
              [key]: form[key]
            }
            substitutosList.push(key)
          }
        }
      }

      substitutosList = [
        ...new Set(
          substitutosList.map((key) =>
            key.replace(/ramalSubstituto|idSubstituto(.*)/g, '$1')
          )
        )
      ]

      substitutosList = substitutosList.flatMap((key) => {
        if (
          substitutoValues[`idSubstituto${key}`] &&
          substitutoValues[`ramalSubstituto${key}`]
        ) {
          return {
            idUsuario: substitutoValues[`idSubstituto${key}`],
            nuRamal: substitutoValues[`ramalSubstituto${key}`]
          }
        }
        return []
      })

      return UserServices()
        .updateRamal(substitutosList)
        .then(() => true)
        .catch(() => {
          showModal({
            message:
              'Houve um erro ao atualizar os ramais dos contrapartes substitutos, tente novamente.',
            txtButtonCancel: '',
            txtButtonConfirm: 'Fechar',
            type: 'error'
          })

          return false
        })
        .finally(() => setLoading('idle'))
    }

    if (!validateSubstitutes(form)) {
      setLoading('idle')
      setSubstituteErrorMsg(
        'Você não pode selecionar um usuário como substituto se ele já for o Contraparte ou Comprador.'
      )
      toggleError()
      return
    }

    if (semPreenchimento) {
      showModal({
        hideButtonCancel: true,
        message: 'Por favor, altere o status do CRE para salvar o contrato.',
        titleModal: 'Atenção',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
      setLoading('idle')
      return
    }

    if (flagContratoEncerrado && arquivosSelecionados.length <= 0) {
      showModal({
        hideButtonCancel: true,
        message: 'Por favor, Anexe evidências que o contrato foi encerrado.',
        titleModal: 'Atenção',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
      setLoading('idle')
      return
    }

    const emailsToSend = [
      ...new Set(
        form.emailsTrabalhistas.map((email: string) => email.toLowerCase())
      )
    ].map((email: string, index) => ({
      contratoId: 0,
      flExclusao: flExclusao[index],
      idContratoNotificacao: 0,
      tipoNotificacaoId: 0,
      txEmail: email
    }))

    const selectedUserFiles = arquivosSelecionados?.filter(
      (files) => files.base64
    )

    const filesToSave: ISaveFileRequest[] =
      selectedUserFiles.length > 0
        ? arquivosSelecionados
          .filter((x) => !x.anexoDocumentoId)
          .map((file: ITypeUpload) => ({
            anexoDocumentoId: file.anexoDocumentoId || 0,
            descricao: file.dsExtensaoDoc,
            file: FORMAT.file(file.base64),
            nomeArquivo:
              file.dsDocumento != '' || file.dsDocumento != null
                ? file.dsDocumento
                : 'DOCUMENTO CONTRATO',

            nuAnoMesCompetencia: parseInt(FORMAT.formatYYYYMM(new Date())),
            tipoDocumentoId: getContractType(),
            tipoPendenciaId: 13,
            usuarioId: user.IdUsuario
          }))
        : []

    const updatedContract = {
      cdContrato: contract.cdContrato || '',
      cdGrupoMercadoria: form.cdGrupoMercadoria,
      cdHierarquiaProd: form.cdHierarquiaProd,
      centroPlantaId: form.centroPlantaId,
      compradorUsuarioId: contract.compradorUsuarioId,
      contraparteUsuarioId: contract.contraparteUsuarioId,
      contratoPrincipalId: contract.contratoPrincipalId,
      dtVigFimReal: form.dtVigFimReal,
      dtVigInicoReal: form.dtVigInicoReal,
      dtVigenciaFim: contract.dtVigenciaFim,
      dtVigenciaInicio: contract.dtVigenciaInicio,
      empresaId: contract.empresaId,
      flAlerta: flagAlerta,
      flAtivo: true,
      listAnexarDocs: filesToSave,
      flDenuncia: flagDenuncia,
      flEncerrado: flagContratoEncerrado,
      flRecorrente: flagRecorrente,
      flSocio: flagSocio,
      flSubcontrato: flagSubcontrato,
      fornecedorId: contract.fornecedorId,
      idContrato: contract.idContrato,
      idUnidGestora: form.idUnidadeGestora,
      itemProdutoId: itemProdutoValue,
      listContraparteSubstituto: idSubstitutoList,
      setorContratoId: form.setorId,
      tipoCreId: form.CRE,
      txAlerta: form.txAlerta,
      txCno: form.txCno,
      txDenuncia: form.txDenuncia,
      txEmail: emailsToSend,
      txObjetoContrato: contract.txObjetoContrato,
      txObservacao: form.txObservacao,
      url: website_url,
      vlContratual: contract.vlContratual
    }

    async function handleSuccessContractUpdate(response?: AxiosResponse) {
      const deleteFilesResponse = await handleDeleteFiles()
      const updateRamalResponse = await handleUpdateRamal()

      if (!updateRamalResponse || !deleteFilesResponse) return

      showModal({
        handleConfirm: () => {
          getContract()
          setTab(0)
        },
        hideButtonCancel: true,
        message: response.data.mensagem || 'Contrato salvo com sucesso.',
        txtButtonConfirm: 'Fechar',
        type: 'success'
      })
    }
    if (updatedContract.dtVigInicoReal != null && updatedContract.dtVigFimReal == null) {
      setLoading('idle')

      showModal({
        message: 'Não é possivel atualizar um contrato que possua data vigência real de inicio e não possua uma data vigência real fim.',
        hideButtonCancel: true,
        txtButtonConfirm: 'OK',
        type: 'error'
      })
      return;
    }
    const handleUpdateContract = async (updatedContract) => {
      try {
        setLoading('loading');
        const response = await ContractNGTServices().update(updatedContract);
        handleSuccessContractUpdate(response);
      } catch (error) {
        setLoading('idle');
        showModal({
          message: 'Não foi possível atualizar o contrato, tente novamente.',
          hideButtonCancel: true,
          txtButtonConfirm: 'OK',
          type: 'error'
        });
      }
    };

    // Chame a função handleUpdateContract com o contrato atualizado
    handleUpdateContract(updatedContract);
  }

  useEffect(() => {
    getContract()
    getDescHirarquiaProd()
  }, [])

  const enviarEmail = async () => {
    setLoading('loading')
    if (inputTypingValue.current) {
      setError('emailsTrabalhistas', {
        message:
          'Existem emails que foram preenchidos parcialmente, pressione espaço para finalizar o preenchimento!',
        type: 'custom'
      })
      return
    }

    await FornecedorServices()
      .supplierEmailValidation({
        idContrato: contract?.idContrato,
        url: website_url
      })
      .then(() => {
        setLoading('idle')
        showModal({
          handleConfirm: () => {
            getContract()
            setTab(0)
          },
          hideButtonCancel: true,
          message: 'E-mail enviado com sucesso!',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })
      })
      .catch(() => {
        // setMsgErro('Erro ao enviar e-mail')
        setLoading('error')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao enviar e-mail.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const getContratoPrincipal = (obj) => {
    setLoading('loading')

    ContractServices()
      .GetContractById(obj.contratoPrincipalId)
      .then((response: any) => {
        const { data: subContract } = response
        if (response.status === 200) {
          setSubContract(subContract)
        }

        setLoading('idle')
      })
      .catch(() => {
        setLoading('error')
        // setMsgErro('Não foi possível obter os dados do contrato.')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os dados do contrato.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleEncerrarContratoFlag = (event) => {
    if (event.target.checked === false) {
      setFlagContratoEncerrado(false)
      setFlagContratoEncerradoWasEnabled(false)
      setArquivosSelecionadosComFlagEncerrado([])
    } else {
      handleChangeInput(event.target.checked, 'flEncerrado')
      setFlagContratoEncerrado(event.target.checked)
      setTimeout(() => {
        if (event.target.checked) {
          showModal({
            hideButtonCancel: true,
            message:
              'Flag de contrato encerrado habilitado! Por favor insira um anexo evidenciando o encerramento',
            txtButtonConfirm: 'Fechar',
            type: 'alert'
          })
          setFlagContratoEncerradoWasEnabled(event.target.checked)
          setArquivosSelecionadosComFlagEncerrado(arquivosSelecionados)
        }
      }, 1000)
    }
  }

  const handleDisabledSalvarButton = () => {
    if (getFieldState('emailsTrabalhistas').invalid) return true

    if (flagContratoEncerradoWasEnabled) {
      const isFileListEquals =
        arquivosSelecionados === arquivosSelecionadosComFlagEncerrado
          ? true
          : false
      const isArquivosSelecionadosLenghtBigger =
        arquivosSelecionados.length >
          arquivosSelecionadosComFlagEncerrado.length
          ? true
          : false
      if (isArquivosSelecionadosLenghtBigger && !isFileListEquals) {
        return false
      } else {
        return true
      }
    }
    return false
  }

  const handleFimVigenciaChange = () => {
    setTimeout(() => {
      if (contract) {
        const dtVigenciaFimInicialString = contract?.dtVigenciaFim
          .toString()
          .slice(0, 10)
        const dtVigenciaAlterada = new Date(watch('dtVigenciaFim'))
        const dtVigenciaAlteradaString = new Date(watch('dtVigenciaFim'))
          .toISOString()
          .slice(0, 10)
        const minimumDateAllowed = new Date('2010-01-01')

        if (
          dtVigenciaFimInicialString !== dtVigenciaAlteradaString &&
          dtVigenciaAlterada > minimumDateAllowed
        ) {
          setFlagContratoEncerrado(false)
          setFlagContratoEncerradoWasEnabled(false)
        }
      }
    }, 3000)
  }

  const verifyValueCRE = (creNameValue) => {
    if (creNameValue == 9) setSemPreenchimento(true);
    else setSemPreenchimento(false);
  }

  useEffect(() => {
    if (arquivosSelecionados) {
      handleFilterFilesTable()
    }
  }, [arquivosSelecionados])

  useEffect(() => {
    verifyValueCRE(creNameValue);
  }, [creNameValue])


  return (
    <>
      <Modal openModal={openModal}>
        <SubContract
          idUnidadeGestora={unidadeGestoraId}
          tipoCre={tipoCre}
          cdHierarquiaProd={descHierarquiaProduto}
          contrato={contract}
          handleCloseModal={() => toggleModal()}
          enviarEmailHandle={enviarEmail}
          unidadeComprador={unidadeCompradorId}
        />
      </Modal>
      <Form
        onSubmit={handleSubmit(handleSubmitForm)}
        onKeyDown={preventDefaultOnEnter}
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <SimpleCollapse title="INFORMAÇÕES GERAIS">
          <Row
            marginTop={SPACING.spacing10}
            marginBottom={SPACING.spacing20}
            justifyContent="space-between"
          >
            <Row marginTop={SPACING.spacing10}>
              <Span
                text="Data Cadastro:"
                fontSize={TYPOGRAPHY.bodySize16}
                fontWeight={FONTS.bold}
                marginRight={SPACING.spacing5}
              />
              <Span
                text={
                  moment(dtCadastro).format('DD/MM/YYYY') == '01/01/0001' ||
                    !dtCadastro
                    ? '---'
                    : FORMAT.formatDDMMYYYY(dtCadastro)
                }
                color={COLORS.blueFonts}
                fontSize={TYPOGRAPHY.bodySize16}
                fontWeight={FONTS.bold}
              />
            </Row>
            <Row justifyContent="flex-end">
              <CheckBox
                marginRight={SPACING.spacing15}
                label="Importado pelo SAP"
                checked={flSap}
              />
              {!isQuarteirizacao && (
                <Button
                  text="Gerar Subcontrato"
                  onClick={() =>
                    contract?.unidadeGestoraId !== 0 &&
                      contract?.nmUnidadeGestora !== ''
                      ? toggleModal()
                      : OpenModalErrorUnidGestora()
                  }
                />
              )}
            </Row>
          </Row>
          <Grid
            gridCols="1fr 1.2fr 2.4fr 1.70fr 1.70fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              control={control}
              errors={errors}
              label="Contrato"
              placeholder="Nº"
              formValue="cdContrato"
              disabled
              min={0}
              width="max-content"
              defaultValue={contract?.cdContrato || ''}
            />

            <Input
              control={control}
              errors={errors}
              label="CPF/CNPJ/Cód.Fornecedor"
              placeholder="Nº"
              formValue="cnpj"
              mask={
                contract?.cnpj && contract?.cnpj.length > 9
                  ? ['###.###.###-##', '##.###.###/####-##']
                  : ['#########']
              }
              disabled
              defaultValue={contract?.cnpj || ''}
            />

            <Input
              control={control}
              errors={errors}
              label="Fornecedor"
              placeholder="Nome do fornecedor"
              formValue="nmFornecedor"
              disabled
              defaultValue={contract?.nmFornecedor || ''}
            />

            <Input
              control={control}
              errors={errors}
              label="Empresa"
              placeholder="Nome da empresa"
              formValue="nmEmpresa"
              disabled
              defaultValue={contract?.nmEmpresa || ''}
            />
            <AutoCompleteInput
              marginTop="0.25rem"
              value={centroPlantaName}
              label="Centro Planta"
              formValue="centroPlantaId"
              options={costCenters}
              key="CentroPlantaInput"
              optionValue="txDescricao"
              valueName="idCentroPlanta"
              disabled />
          </Grid>
          <Grid
            gridCols="4fr 3fr 3fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <TextArea
              disabled
              count={contract?.txObjetoContrato.length || 0}
              label="Objeto do contrato"
              control={control}
              errors={errors}
              formValue="txObjetoContrato"
              limitCount={150}
              maxLength={150}
              value={contract?.txObjetoContrato || ''}
            />
            <AutoCompleteSearchTerm
              control={control}
              errors={errors}
              label="CRE"
              formValue="CRE"
              options={tipoCre || []}
              optionLabel="txDenominacao"
              optionValue="idTipoCre"
              onChange={(_event, value) => handleChangeInput(value, 'creName')}
              defaultValue={contract?.nmCRE || ''}
            />
            <Input
              control={control}
              errors={errors}
              mask={['##.###.#####/##']}
              label="CNO ( Cadastro Nacional de Obras )"
              placeholder="CNO"
              formValue="txCno"
              defaultValue={contract?.txCno || ''}
            />
          </Grid>

          <Grid
            gridCols="1fr 1fr 1fr 1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Picker
              defaultValue={dateNow}
              label="Início Vigência Contrato"
              formValue="dtVigenciaInicio"
              id="IniVigContrato"
              control={control}
              disabled
            />
            <Picker
              defaultValue={dateNow}
              label="Fim Vigência Contrato"
              formValue="dtVigenciaFim"
              id="FimVigContrato"
              control={control}
              disabled
              onChange={
                handleFimVigenciaChange() as unknown as (_event: any) => void
              }
            />
            <Picker
              defaultValue={dateNow}
              label="Início Vigência Real"
              formValue="dtVigInicoReal"
              maxDate={moment(dtVigFimReal)}
              control={control}
            />
            <Picker
              defaultValue={dateNow}
              label="Fim Vigência Real"
              formValue="dtVigFimReal"
              minDate={moment(dtVigInicoReal)}
              control={control}
            />
          </Grid>

          <Grid
            gridCols="1fr 1fr 0.30fr 0.30fr 0.30fr 1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              control={control}
              errors={errors}
              label="Valor Contratual"
              placeholder="Valor"
              formValue="vlContratual"
              disabled
              min={0}
              defaultValue={contract?.vlContratual.toString() || ''}
            />

            <AutoCompleteSearchTerm
              defaultValue={''}
              value={setorName}
              options={sectors}
              optionLabel="dsSetorContrato"
              label="Negócio"
              control={control}
              errors={errors}
              formValue="setorId"
              optionValue="idSetorContrato"
            />
            {/* <Autocomplete
              disablePortal
              id="sectors"
              value={setorName}
              onChange={(event, value) => {
                const setorSelecionado = sectors.find(setor => setor.txDenominacao == value)

                if (setorSelecionado) {
                  handleChangeInput(setorSelecionado.idSetor, 'setorId')
                  handleChangeInput(setorSelecionado.txDenominacao, 'setorName')
                } else {
                  handleChangeInput(0, 'setor')
                }
              }}
              options={sectors?.length > 0 && sectors.map(sector => sector.txDenominacao)}
              renderInput={(params) => <TextField {...params}  label="Setor" variant="standard"/>}
            /> */}
            <Col>
              <Span text="Tipo" />
              <CheckBox
                checked={flagRecorrente}
                label="Recorrente"
                onClick={(event) => {
                  handleChangeInput(event.target.checked, 'flRecorrente')
                  setFlagRecorrente(event.target.checked)
                }}
              />
            </Col>
            <Col>
              <Span text="Contrato" />
              <CheckBox
                // checked={dtVigFimReal ? true : false}
                checked={flagContratoEncerrado}
                label="Encerrado"
                onChange={(event) => {
                  handleEncerrarContratoFlag(event)
                }}
              />
            </Col>
            <CheckBox
              marginTop="1rem"
              checked={flagSocio}
              label="Sócio"
              onClick={(event) => {
                handleChangeInput(event.target.checked, 'flSocio')
                setFlagSocio(event.target.checked)
              }}
            />
            <Picker
              value={dataAtualizacaoSAP}
              label="Data Atualização SAP"
              disabled
            />
          </Grid>

          <Span fontSize="1em" text="Notificação" />
          <Grid
            gridCols={
              !isSub ? '0.8fr 0.8fr 0.8fr 2fr 2fr' : '0.8fr 0.8fr 2fr 2fr'
            }
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <CheckBox
              checked={flagDenuncia}
              label="Denúncia"
              onClick={(event) => {
                handleChangeInput(event.target.checked, 'flDenuncia')
                setFlagDenuncia(event.target.checked)
                if (!event.target.checked) {
                  handleChangeInput('', 'txDenuncia')
                }
              }}
            />
            <CheckBox
              checked={flagAlerta}
              label="Alerta"
              onClick={(event) => {
                handleChangeInput(event.target.checked, 'flAlerta')
                setFlagAlerta(event.target.checked)
                if (!event.target.checked) {
                  handleChangeInput('', 'txAlerta')
                }
              }}
            />
            {!isSub && (
              <CheckBox
                checked={flagSubcontrato}
                label="Solicitação Subcontrato"
                onClick={(event) => {
                  handleChangeInput(event.target.checked, 'flSubcontrato')
                  setFlagSubcontrato(event.target.checked)
                }}
              />
            )}
            <Input
              maxLength={1000}
              control={control}
              errors={errors}
              label="Denúncia"
              placeholder="Justifique"
              formValue="txDenuncia"
              disabled={!flagDenuncia}
              defaultValue={contract?.txDenuncia || ''}
            />
            <Input
              maxLength={1000}
              control={control}
              errors={errors}
              label="Alerta"
              placeholder="Justifique"
              formValue="txAlerta"
              disabled={!flagAlerta}
              defaultValue={contract?.txAlerta || ''}
            />
          </Grid>
          <Grid
            gridCols="1.1fr 2fr 1fr 2.9fr 0.5fr 0.5fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              control={control}
              errors={errors}
              disabled
              label="Matrícula Contraparte"
              placeholder="Nº"
              formValue="matriculaContraparte"
              required
              min={0}
              defaultValue={contract?.matriculaContraparte || ''}
            />
            <Input
              control={control}
              errors={errors}
              disabled
              label="Contraparte"
              formValue="nmContraparte"
              placeholder="Nome do Contraparte"
              required
              defaultValue={contract?.nmContraparte || ''}
            />
            <Input
              disabled
              type="number"
              control={control}
              errors={errors}
              label="Ramal"
              formValue="ramalContraparte"
              placeholder="Nº"
              required
              min={0}
              defaultValue={contract?.ramalContraparte || ''}
            />
            <Input
              disabled
              type="email"
              control={control}
              errors={errors}
              label="E-mail"
              formValue="emailContraparte"
              placeholder="Endereço de E-mail"
              required
              defaultValue={contract?.emailContraparte || ''}
            />
          </Grid>

          {substitutoList.length === 0 && addSubstituto}

          {substitutoList.length > 0 &&
            substitutoList.map((input, index) => (
              <>
                <Grid
                  key={index}
                  gridCols="1.1fr 2fr 1fr 2.9fr 0.5fr 0.5fr"
                  gridGap={`0 ${SPACING.spacing20}`}
                  margin={`0 0 ${SPACING.spacing30} 0`}
                >
                  <AutoCompleteInput
                    name="matriculaSubstituto"
                    onChangeText={handleSearchMatricula}
                    value={input?.matriculaSubstituto}
                    options={matriculas}
                    optionValue="label"
                    label="Matrícula Substituto"
                    onChange={(_, value) => {
                      handleSelectedSubstituto(value, index)
                    }}
                    valueName="value"
                    noFilter
                    marginTop="0.25rem"
                  />
                  <AutoCompleteInput
                    name="nmSubstituto"
                    onChangeText={handleSearchAnalista}
                    value={input?.nmSubstituto}
                    options={analistas}
                    optionValue="label"
                    label="Nome do Substituto"
                    onChange={(_, value) => {
                      handleSelectedSubstituto(value, index)
                    }}
                    valueName="value"
                    noFilter
                    marginTop="0.25rem"
                  />
                  <Input
                    name='ramalSubstituto'
                    type="number"
                    errors={errors}
                    control={control}
                    label="Ramal"
                    placeholder="Nº"
                    formValue={substitutoList[index]?.ramalSubstituto || ''}
                    onChange={(event) => handleInputChange(index, event)}
                    min={0}
                  />
                  <Input
                    disabled
                    type="email"
                    label="E-mail"
                    value={input?.emailSubstituto?.toUpperCase() || ''}
                    placeholder="Endereço de E-mail"
                    defaultValue={input?.emailSubstituto?.toUpperCase() || ''}
                  />
                  <Button text="+" onClick={addSubstituto} />
                  {
                    <Button
                      text="-"
                      onClick={() => removeSubstitutoInput(index)}
                    />
                  }
                </Grid>
              </>
            ))}

          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Grid
              gridCols="1.1fr 2fr 1fr 2.9fr 1.1fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing10} 0`}
            >
              <Input
                control={control}
                label="Matrícula Comprador"
                placeholder="Nº"
                disabled
                formValue="matriculaComprador"
                min={0}
              />
              <Input
                control={control}
                label="Comprador"
                placeholder="Nome do Comprador"
                disabled
                formValue="nmComprador"
              />
              <Input
                type="number"
                control={control}
                label="Ramal"
                placeholder="Nº"
                disabled
                formValue="ramalComprador"
                min={0}
              />
              <Input
                type="email"
                control={control}
                label="E-mail"
                placeholder="Endereço de E-mail"
                formValue="emailComprador"
                disabled
              />
              <Input
                control={control}
                type="number"
                label="Unidade do Comprador"
                placeholder="Unidade do Comprador"
                formValue="unidadeComprador"
                min={0}
                disabled
              />
            </Grid>

            <div style={{ display: 'flex', justifyContent: 'flex-start', margin: '16px 0' }}>
              <CheckBox
                checked={flagUnidadeManual}
                label="Unidade Manual"
                disabled={true}
              />
            </div>

            <UnidadeGestoraFields
              gridCols={{
                Diretoria: 6,
                DiretoriaExecutiva: 6,
                Gerencia: 6,
                GerenciaGeral: 6,
                Unidade: 12,
                spacing: 1,
              }}
              renderUnidadeSelect
              defaultValue={unidadeGestoraId}
              disableFields={[
                'DiretoriaExecutiva',
                'Diretoria',
                'GerenciaGeral',
                'Gerencia',
              ]}
              control={control}
              formValue="idUnidadeGestora"
              disabled={isSub ? true : false}
            />
          </div>

          {
            <Row justifyContent={'space-between'} alignItems="center">
              {itemProdutos ? (
                itemProdutos.map((item) =>
                  alterarItemProduto ? (
                    <Grid
                      width="93%"
                      gridCols="0.1fr 0.4fr 0.3fr 0.9fr 0.9fr 0.9fr 0.8fr"
                      gridGap={`0 ${SPACING.spacing20}`}
                      margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
                    >
                      <CheckBox
                        checked={
                          itemProdutoValue == item?.idItemProduto?.toString()
                        }
                        onClick={() => {
                          handleChangeInput(
                            item?.centroPlantaId,
                            'centroPlantaId'
                          )
                          handleChangeInput(
                            item?.descCentroPlanta,
                            'centroPlantaName'
                          )
                          setItemProdutoValue(item?.idItemProduto?.toString())
                        }}
                      />
                      <Input
                        label="Item"
                        placeholder="N° Item Prod."
                        value={item.cdOrdemItem}
                        disabled
                      />
                      <Input
                        label="Cód. Grupo Mercadoria"
                        placeholder="Cód."
                        value={item.codGrupoMercadoria}
                        disabled
                      />
                      <Input
                        label="Descrição do Grupo Mercadoria"
                        placeholder="Descrição"
                        value={item.descGrupoMercadoria}
                        disabled
                      />
                      <Input
                        label="Cód. Hierarquia Produto"
                        placeholder="Cód."
                        disabled
                        value={item.codHierarquiaProduto}
                      />
                      <Input
                        label="Descrição Hierarquia Produto"
                        placeholder="Descrição"
                        value={item.descHierarquiaProduto}
                        disabled
                      />
                      <AutoCompleteInput
                        marginTop="0.25rem"
                        value={item.descCentroPlanta}
                        options={costCenters}
                        label="Centro Planta"
                        placeholder="CENTRO PLANTA"
                        disabled
                        optionValue="txDescricao"
                        valueName="idCentroPlanta"
                      />
                    </Grid>
                  ) : (
                    item?.idItemProduto?.toString() == itemProdutoValue && (
                      <Grid
                        width="93%"
                        gridCols="0.1fr 0.4fr 0.3fr 0.9fr 0.9fr 0.9fr"
                        gridGap={`0 ${SPACING.spacing20}`}
                        margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
                      >
                        <CheckBox
                          checked={
                            itemProdutoValue == item?.idItemProduto?.toString()
                          }
                          onClick={() => {
                            handleChangeInput(
                              item?.centroPlantaId,
                              'centroPlantaId'
                            )
                            handleChangeInput(
                              item?.descCentroPlanta,
                              'centroPlantaName'
                            )
                            setItemProdutoValue(item?.idItemProduto?.toString())
                          }}
                        />
                        <Input
                          label="Item"
                          placeholder="N° Item Prod."
                          value={item.cdOrdemItem}
                          disabled
                        />
                        <Input
                          label="Cód. Grupo Mercadoria"
                          placeholder="Cód."
                          value={item.codGrupoMercadoria}
                          disabled
                        />
                        <Input
                          label="Descrição do Grupo Mercadoria"
                          placeholder="Descrição"
                          value={item.descGrupoMercadoria}
                          disabled
                        />
                        <Input
                          label="Cód. Hierarquia Produto"
                          placeholder="Cód."
                          disabled
                          value={item.codHierarquiaProduto}
                        />
                        <Input
                          label="Descrição Hierarquia Produto"
                          placeholder="Descrição"
                          value={item.descHierarquiaProduto}
                          disabled
                        />
                      </Grid>
                    )
                  )
                )
              ) : (
                <LoadingIcon
                  colorIcon={COLORS.blueFonts}
                  marginTop={SPACING.spacing20}
                />
              )}
              <Grid
                gridCols="100%"
                margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
              >
                <Button
                  text={alterarItemProduto ? 'Salvar' : 'Alterar'}
                  onClick={() =>
                    itemProdutos && itemProdutos.length > 1
                      ? setAlterarItemProduto(!alterarItemProduto)
                      : showModal({
                        hideButtonCancel: true,
                        message: 'Não encontramos mais de um item produto.',
                        titleModal: 'Atenção',
                        txtButtonConfirm: 'OK',
                        type: 'alert'
                      })
                  }
                  marginLeft={SPACING.spacing10}
                />
              </Grid>
            </Row>
          }

          <Grid
            gridCols="8fr "
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <ChipInput
              mensagem="Pressione espaço para selecionar um E-mail"
              errors={errors}
              control={control}
              enableInsertOnEnter
              label="E-mail documentação trabalhista"
              formValue="emailsTrabalhistas"
              onKeyUp={(event) => {
                const email = event?.target?.value?.trim() // Mova esta linha para fora do bloco else
                if (event?.target?.value?.trim()) {
                  // Verifique se há um email antes de prosseguir
                  const emailsTrabalhistas = getValues('emailsTrabalhistas')
                  const emailDuplicado = emailsTrabalhistas.includes(email)
                  setError('emailsTrabalhistas', {
                    message:
                      'E-mail não confirmado! Pressione ENTER caso queira incluí-lo.',
                    type: 'custom'
                  })
                  if (emailDuplicado) {
                    setError('emailsTrabalhistas', {
                      message:
                        'E-mail já cadastrado neste contrato, por favor, digite outro',
                      type: 'custom'
                    })
                  }
                  return
                }
                clearErrors('emailsTrabalhistas')
              }}
              onBlur={(event) => {
                if (event?.target?.value?.trim()) {
                  inputTypingValue.current = event?.target?.value?.trim()
                  return
                }
                clearErrors('emailsTrabalhistas')
                inputTypingValue.current = event?.target?.value?.trim()
              }}
              placeholder=""
              only="email"
              flExclusao={flExclusao}
              setFlExclusao={setFlExclusao}
            />
          </Grid>
          <Grid
            gridCols="8fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing5} 0`}
          >
            <Input
              maxLength={500}
              control={control}
              label="Observação"
              formValue="txObservacao"
              multiline
            />
          </Grid>
        </SimpleCollapse>

        {isSub && (
          <SimpleCollapse title="DADOS DO CONTRATO PRINCIPAL">
            <Grid
              gridCols="1fr 3.5fr 3.5fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
            >
              <Input
                label="Contrato"
                placeholder="Nº"
                value={subContract?.cdContrato || null}
                disabled
              />
              <Input
                value={subContract?.nmFornecedor || null}
                label="Fornecedor"
                placeholder="Nome do Fornecedor"
                disabled
              />

              <Input
                value={subContract?.txObservacao || null}
                disabled
                label="Observação"
                placeholder="Observação"
                multiline
              />
            </Grid>
            <Grid
              gridCols="2fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
            >
              <TextArea
                value={subContract?.txObjetoContrato || null}
                disabled
                label="Objeto do contrato"
                placeholder="Objeto do contrato"
                count={subContract?.txObjetoContrato?.length}
                limitCount={150}
                maxLength={150}
              />
            </Grid>
          </SimpleCollapse>
        )}

        {loadingEvidencia ? (
          <LoadingIcon
            colorIcon={COLORS.blueFonts}
            marginTop={SPACING.spacing20}
          />
        ) : (
          <SimpleCollapse title="ANEXAR EVIDÊNCIAS">
            <Grid
              gridCols="6fr 3fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
            >
              <InputFile
                onChange={(files) => {
                  const twoGigaBytes = 17179869184

                  if (files[0].size >= twoGigaBytes) {
                    showModal({
                      hideButtonCancel: true,
                      message:
                        'O arquivo anexado não pode ter tamanho maior que 2GB',
                      titleModal: 'Atenção',
                      txtButtonConfirm: 'OK',
                      type: 'alert'
                    })
                    return
                  }
                  handleChangeFile(files)
                }}
                renderInput={false}
                required
              />
              {arquivosSelecionados.length > 0 && (
                <Input
                  value={searchFile}
                  label="Pesquisa Geral"
                  placeholder="Pesquisar"
                  onChange={(e) => setSearchFile(e.target.value)}
                  inputIcon={<MagnifyingGlassIcon />}
                />
              )}
            </Grid>
            {arquivosSelecionados.length > 0 && (
              <Grid
                gridCols="12fr"
                gridGap={`0 ${SPACING.spacing20}`}
                margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
              >
                <FakeAttachedFiles
                  tableData={handleFilterFilesTable()}
                  handleDeleteFile={handleFileToDelete}
                />
              </Grid>
            )}
          </SimpleCollapse>
        )}

        <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
          <Button
            text="Salvar e Finalizar"
            type="submit"
            marginLeft={SPACING.spacing20}
            disabled={handleDisabledSalvarButton()}
          />
          <Button
            text="Limpar"
            variantButton="text"
            marginLeft={SPACING.spacing15}
            marginRight={SPACING.spacing15}
            onClick={handleClearForm}
          />
          <Button
            text="ENVIAR E-MAIL"
            variantButton="outlined"
            onClick={enviarEmail}
            marginLeft={SPACING.spacing20}
          />
        </Row>
      </Form>
      <SuccessModal
        message={substituteErrorMsg}
        open={isError}
        type="error"
        handleConfirm={toggleError}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
      <SuccessModal
        message={successMsg}
        open={isSuccess}
        type="sucess"
        handleConfirm={() => setSuccess(false)}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
    </>
  )
}
